module.exports = __webpack_public_path__ + "img/my-firstcall.e9c588d9.jpg";